// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mqI1p85XmC2MaW {
  position: relative;
  box-sizing: border-box;
  width: 768px;
  overflow: hidden;
  border-radius: var(--ds-radius-xlarge, 12px);
  background-color: var(--ds-surface-overlay, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31));
}
.mqI1p85XmC2MaW:focus {
  outline: 0;
}
.mqI1p85XmC2MaW.WrM38QGz89i4ij {
  width: 768px;
}
.mqI1p85XmC2MaW.GEdu4Dn5rTEUDE {
  width: 584px;
}
.mqI1p85XmC2MaW.HCPH9JqcbIJ5SC {
  width: 500px;
}
@media print {
  .mqI1p85XmC2MaW {
    /* stylelint-disable-next-line declaration-no-important */
    width: 100vw !important;
    /* stylelint-disable-next-line declaration-no-important */
    border-radius: 0 !important;
  }
}
.yqquoDle3KgS1X {
  border: none;
  background-color: transparent;
  box-shadow: none;
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) auto;
  border-radius: var(--ds-radius-full, 50%);
}
.yqquoDle3KgS1X:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  box-shadow: none;
}
.yqquoDle3KgS1X:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  box-shadow: none;
}
.yqquoDle3KgS1X:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .yqquoDle3KgS1X:focus {
  outline-color: -webkit-focus-ring-color;
}
.yqquoDle3KgS1X:focus .mac.firefox {
  outline-color: AccentColor;
}
.yqquoDle3KgS1X .cMcSJ6d3jjVbP6 {
  margin: var(--ds-space-0, 0);
}
@media only screen and (max-width: 750px), only screen and (max-width: 450px) {
  .mqI1p85XmC2MaW {
    width: auto;
    margin: var(--ds-space-0, 0) var(--ds-space-100, 8px);
  }
  .mqI1p85XmC2MaW.WrM38QGz89i4ij,
  .mqI1p85XmC2MaW.GEdu4Dn5rTEUDE,
  .mqI1p85XmC2MaW.HCPH9JqcbIJ5SC {
    width: auto;
  }
  .mqI1p85XmC2MaW .cMcSJ6d3jjVbP6 {
    margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-150, 12px) var(--ds-space-150, 12px);
  }
}
`, ""]);
// Exports
export var dialog = `mqI1p85XmC2MaW`;
export var large = `WrM38QGz89i4ij`;
export var medium = `GEdu4Dn5rTEUDE`;
export var small = `HCPH9JqcbIJ5SC`;
export var closeButton = `yqquoDle3KgS1X`;
export var body = `cMcSJ6d3jjVbP6`;
export default ___CSS_LOADER_EXPORT___;
